import { PayloadAction, createSlice, nanoid } from '@reduxjs/toolkit';
import { LegalTab, State, ToastStatus } from './types';
import {
    getCitiesThunk,
    getStatesThunk,
    getCountriesThunk,
} from './thunks';

const initialState: State = {
    notification: [],
    citiesList: [],
    countriesList: [],
    statesList: [],
    legalTab: 'Privacy_Policy',
};

export const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        setNotification: (state, action: PayloadAction<[string, ToastStatus]>) => {
            const toastProps = {
                id: nanoid(),
                message: action.payload[0],
                status: action.payload[1]
            };

            state.notification.push(toastProps);
        },
        removeNotification: (state) => {
            state.notification.shift();
        },
        setLegalTab: (state, action: PayloadAction<LegalTab>) => {
            state.legalTab = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCountriesThunk.fulfilled, (state, action) => {
                state.countriesList = action.payload;
            })
            .addCase(getStatesThunk.fulfilled, (state, action) => {
                state.statesList = action.payload;
            })
            .addCase(getCitiesThunk.fulfilled, (state, action) => {
                state.citiesList = action.payload;
            })

    }
});

export const {
    setLegalTab,
    setNotification,
    removeNotification,
} = generalSlice.actions;